import { PageNames } from 'ep-bt-controls';
import { EpbtFaGridBaseModel } from './epbt-fa-grid-base-model';

export class EpbtFaProductGridModel extends EpbtFaGridBaseModel {
    constructor(bistrackSettings, webTrackUser, branchId, fromPage: string = PageNames.ProductSearch, loadDataOnload: boolean = false) {
        super(bistrackSettings, webTrackUser, loadDataOnload);
        this.fromPage = fromPage;
        this.branchId = branchId;
    }
    fromPage: string;
    branchId: number;
}



